module.exports = __webpack_public_path__ + "static/img/8.4ed7551.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/1/sp/8.png
// module id = 7nhe
// module chunks = 0